import React from 'react'

const User = () => {
    return (
        <>
            <div className="row mt-4">
                <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <div class="usercardesign">
                                <div class="avatarimg">
                                    <img src="https://lh3.googleusercontent.com/a/ACg8ocIFvD6_nIphfRaYNt70nObMROoKOIAqvmv1XxRm2hHJGw=s96-c" style={{ objectFit: 'cover' }} alt="Avatar for Simulanis India" title="Simulanis India" />
                                </div>
                                <h6 class="groupname mb-0">Sunil Kumar Yadav</h6>
                                <p className='font-xss mb-0'>sunilyadav@simulanis.com</p>
                                <p className='font-xss' style={{ color: '#ccc' }}>Web Designer</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <div class="usercardesign">
                                <div class="initials-placeholder">AP</div>
                                <h6 class="groupname mb-0">Avish Pratap Singh</h6>
                                <p className='font-xss mb-0'>sunilyadav@simulanis.com</p>
                                <p className='font-xss' style={{ color: '#ccc' }}>Web Designer</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <div class="usercardesign">
                                <div class="avatarimg">
                                    <img src="https://lh3.googleusercontent.com/a/ACg8ocIFvD6_nIphfRaYNt70nObMROoKOIAqvmv1XxRm2hHJGw=s96-c" style={{ objectFit: 'cover' }} alt="Avatar for Simulanis India" title="Simulanis India" />
                                </div>
                                <h6 class="groupname mb-0">Sunil Kumar Yadav</h6>
                                <p className='font-xss mb-0'>sunilyadav@simulanis.com</p>
                                <p className='font-xss' style={{ color: '#ccc' }}>Web Designer</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default User
